import { useState } from 'react';

import { resolveFileUrl } from '@/api/client';

import { initials } from './format';

/**
 * The picture beside the account: the company's logo, or the person's own
 * photo, otherwise their initials. One that fails to load falls back too, so
 * the corner is never a broken image.
 */
export function AccountAvatar({ fullName, company = null, photoUrl = null }) {
  const image = company?.logoUrl ?? photoUrl;
  const src = image ? resolveFileUrl(image) : null;
  // Remembers which address failed, so a newly uploaded logo gets its chance.
  const [failed, setFailed] = useState(null);

  if (src && src !== failed) {
    return (
      <span className="border-line bg-surface grid size-8 shrink-0 place-items-center overflow-hidden rounded-md border">
        <img
          src={src}
          alt={company ? `${company.name} logo` : `${fullName}`}
          onError={() => setFailed(src)}
          className={company ? 'size-full object-contain p-0.5' : 'size-full object-cover'}
        />
      </span>
    );
  }
  return (
    <span className="bg-brand-600 grid size-7 shrink-0 place-items-center rounded-full text-[10px] font-semibold text-white">
      {initials(fullName)}
    </span>
  );
}
